<svg:g
  *ngFor="let point of points$ | async"
  attr.transform="translate({{ point.join(',') }})"
>
  <circle class="model-input-point" r="1"></circle>
</svg:g>
